//bootstrap components:
import { Container, Row, Col, Image, Card } from 'react-bootstrap'
import sanityClient from '../client'
import imageUrlBuilder from '@sanity/image-url'
// import BlockContent from '@sanity/block-content-to-react'
const builder = imageUrlBuilder(sanityClient)
function urlFor(source) {
    return builder.image(source)
}
//this is our setup for image-url which we imported from sanity

export default function CardSubPageSection({ subPageData }) {
    return (
        <>



     
        <div className=''
       >
           <h4 className="display-3 text-center my-2 text-white"
                style={{textShadow: "0.2rem 0.2rem black"}}>
                    Areas of Activism
                </h4>
              <Row>



              

            <Row
                // className="flex-wrap flex-column justify-content-start align-items-start m-auto subpage-section"
                className="flex-wrap flex-column justify-content-start align-items-center m-auto subpage-section"
           
            >
                 
                {subPageData.map(subPage => (
                    <Col
                        key={subPage.slug.current}
                        className="g-3"
                        //remember: g refers to 'gutter' and you can do gx and gy etc
                        lg={4}
                        // xxl={2}
                    >
                        <Card
                     
                            className="my-1 card-primary text-center shadow-sm  border-primary"
                        >
                            <Card.Link
                                href={'/activism/' + subPage.slug.current}
                                className=""
                            >
                                <Card.Body>
                                    <Card.Title className="my-lg-2 py-lg-1 px-xxl-4 fs-4">
                                        {/* <h4> {subPage.title} </h4> */}
                                        {subPage.title}
                                    </Card.Title>
                                    <Card.Text className="my-3">
                                        {subPage.subTitle}
                                    </Card.Text>
                                </Card.Body>
                            </Card.Link>
                        </Card>
                    </Col>
                ))}
            </Row>

         
            </Row>
        </div>
        </>
    )
}
